import { breakpoints } from '@altermaind/web/ui';
import { keyframes, animations } from './animations';
import { radii, borderWidths } from './borders';
import { colorsDark } from './colors.dark';
import { colorsLight } from './colors.light';
import {
  card,
  spacer,
  typography,
  switchStyle,
  radio,
  chip,
  grid,
  loader,
  asset,
  box,
  multipleLine,
  buttonLight,
  buttonDark,
  checkboxLight,
  checkboxDark,
  formInputDark,
  formInputLight,
  inputDark,
  inputLight,
  animatedShapeDark,
  animatedShapeLight,
  datepicker,
  datepickerArrows,
  datepickerDays,
  datepickerHeader,
  datepickerSelector,
  datepickerSingleDay,
  dropDownDark,
  dropDownOptionsContainerDark,
  dropDownHeaderDark,
  optionDark,
  dropDownLight,
  dropDownHeaderLight,
  dropDownOptionsContainerLight,
  optionLight,
  textInputLight,
  textInputDark,
  timepicker,
  timepickerSelector,
} from './components';
import { fontFamilies, fontSizes, lineHeights } from './fonts';
import { gradientsDark } from './gradients.dark';
import { gradientsLight } from './gradients.light';
import { shadows } from './shadows';
import { sizes } from './sizes';
import { space } from './space';

export const themeShared = {
  keyframes,
  animations,
  fonts: fontFamilies,
  lineHeights,
  fontSizes,
  radii,
  borderWidths,
  shadows,
  space,
  sizes,
  breakpoints,
  components: {
    Box: box,
    Card: card,
    Spacer: spacer,
    Typography: typography,
    Switch: { ...switchStyle },
    Radio: { ...radio },
    Chip: { ...chip },
    Grid: { ...grid },
    Loader: { ...loader },
    Asset: asset,
    MultipleLine: multipleLine,
    Datepicker: datepicker,
    DatepickerSelector: datepickerSelector,
    DatepickerHeader: datepickerHeader,
    DatepickerDays: datepickerDays,
    DatepickerLeftChevron: datepickerArrows,
    DatepickerRightChevron: datepickerArrows,
    DatepickerSingleDay: datepickerSingleDay,
    Timepicker: timepicker,
    TimepickerSelector: timepickerSelector,
  },
};

export const themeDark = {
  colors: {
    ...colorsDark,
  },
  ...themeShared,
  gradients: {
    ...gradientsDark,
  },
  components: {
    ...themeShared.components,
    TextInput: textInputDark,
    Input: inputDark,
    Checkbox: checkboxDark,
    CheckboxEffects: checkboxDark,
    Button: buttonDark,
    FormInput: { ...formInputDark },
    AnimatedShape: animatedShapeDark,
    DropDown: dropDownDark,
    DropDownHeader: dropDownHeaderDark,
    DropDownOptionsContainer: dropDownOptionsContainerDark,
    Option: optionDark,
  },
};

export const themeLight = {
  colors: {
    ...colorsLight,
  },
  ...themeShared,
  gradients: {
    ...gradientsLight,
  },
  components: {
    ...themeShared.components,
    TextInput: textInputLight,
    Input: inputLight,
    Checkbox: checkboxLight,
    CheckboxEffects: checkboxLight,
    Button: buttonLight,
    FormInput: { ...formInputLight },
    AnimatedShape: animatedShapeLight,
    DropDown: dropDownLight,
    DropDownHeader: dropDownHeaderLight,
    DropDownOptionsContainer: dropDownOptionsContainerLight,
    Option: optionLight,
  },
};
